module.exports = __webpack_public_path__ + "img/button-software-disabled.5ef4b727.svg";